// Árvore do plano de contas: um dígito no 1º nível e dois nos seguintes, até cinco níveis
const FORMATO_CODIGO = /^[0-9](\.[0-9]{2}){0,4}$/
const NIVEL_MAXIMO = 5

export const codigoValido = codigo => typeof codigo === "string" && FORMATO_CODIGO.test(codigo)

export const nivelDoCodigo = codigo => codigo.split(".").length

// R é receita; D ou vazio (como no legado) é despesa
export const naturezaDe = tipo => (tipo === "R" ? "R" : "D")

const codigoPai = codigo => {
  const fim = codigo.lastIndexOf(".")
  return fim === -1 ? null : codigo.substring(0, fim)
}

const finalDoCodigo = codigo => parseInt(codigo.substring(codigo.lastIndexOf(".") + 1), 10)

const irmas = (contas, pai) => contas
  .filter(conta => codigoPai(conta.codigo) === pai)
  .sort(porCodigo)

// Comparação simples de texto: localeCompare pode ignorar o ponto conforme o navegador
const porCodigo = (a, b) => (a.codigo < b.codigo ? -1 : a.codigo > b.codigo ? 1 : 0)

const ehDescendente = (codigo, ancestral) => codigo.startsWith(`${ ancestral }.`)

export const montarLinhas = (contas, recolhidos = new Set()) => {
  const ordenadas = [...contas].sort(porCodigo)
  return ordenadas.map(conta => {
    const doMesmoPai = irmas(ordenadas, codigoPai(conta.codigo))
    return {
      ...conta,
      nivel: nivelDoCodigo(conta.codigo),
      temFilhas: ordenadas.some(outra => ehDescendente(outra.codigo, conta.codigo)),
      visivel: ![...recolhidos].some(recolhido => ehDescendente(conta.codigo, recolhido)),
      primeiraIrma: doMesmoPai[0].codigo === conta.codigo,
      ultimaIrma: doMesmoPai[doMesmoPai.length - 1].codigo === conta.codigo,
    }
  })
}

// Próxima irmã livre abaixo de codigoPai (null = 1º nível); null quando não há espaço
export const proximoCodigo = (contas, codigoPaiAlvo) => {
  if (codigoPaiAlvo && nivelDoCodigo(codigoPaiAlvo) >= NIVEL_MAXIMO) return null
  const limite = codigoPaiAlvo ? 99 : 9
  const usados = new Set(irmas(contas, codigoPaiAlvo).map(conta => finalDoCodigo(conta.codigo)))
  const maior = usados.size ? Math.max(...usados) : 0
  let final = maior + 1
  if (final > limite) {
    final = Array.from({ length: limite }, (_, i) => i + 1).find(n => !usados.has(n))
    if (!final) return null
  }
  if (!codigoPaiAlvo) return String(final)
  return `${ codigoPaiAlvo }.${ String(final).padStart(2, "0") }`
}

// Troca a conta de posição com a irmã vizinha: as duas trocam de código e as subcontas acompanham
export const moverConta = (contas, codigo, direcao) => {
  const doMesmoPai = irmas(contas, codigoPai(codigo))
  const posicao = doMesmoPai.findIndex(conta => conta.codigo === codigo)
  const vizinha = doMesmoPai[direcao === "subir" ? posicao - 1 : posicao + 1]
  if (posicao === -1 || !vizinha) return contas

  const trocar = (atual, de, para) => para + atual.substring(de.length)
  return contas.map(conta => {
    if (conta.codigo === codigo || ehDescendente(conta.codigo, codigo)) {
      return { ...conta, codigo: trocar(conta.codigo, codigo, vizinha.codigo) }
    }
    if (conta.codigo === vizinha.codigo || ehDescendente(conta.codigo, vizinha.codigo)) {
      return { ...conta, codigo: trocar(conta.codigo, vizinha.codigo, codigo) }
    }
    return conta
  })
}
